(
    function() {
        /* Desktop navigation support */
        var check_desktop = document.getElementById('main-menu__toggle');
        var check_shop_button = document.getElementById('shop-menu__toggle');

        var desktop_menu_activation = document.getElementById('desktop-menu-activation-area');
        var shop_menu_activation = document.getElementById('shop-menu-activation-area');

        var opening = true;

        var isShopMenuOpen = false;
        var isMainMenuOpen = false;

        function on_outside_click(e) {
            if (opening) {
                if (e.target.id === 'shop-menu__toggle' && isShopMenuOpen === false) {

                    if (isMainMenuOpen) {
                        isMainMenuOpen = false;
                        check_desktop.checked = false;
                        check_shop_button.checked = false;
                    }

                    isShopMenuOpen = true;
                    check_shop_button.checked = true;
                    check_desktop.checked = false;

                    return;
                }

                if (e.target.id === 'shop-menu__toggle' && isShopMenuOpen === true) {
                    
                    isShopMenuOpen = false;
                    check_shop_button.checked = false;
                    check_desktop.checked = false;

                    return;
                }

                if (e.target.id === 'main-menu__toggle' && isMainMenuOpen === false) {
                    
                    if (isShopMenuOpen) {
                        isShopMenuOpen = false;
                        check_desktop.checked = false;
                        check_shop_button.checked = false;
                    }

                    isMainMenuOpen = true;
                    check_desktop.checked = true;
                    check_shop_button.checked = false;

                    return;
                }

                if (e.target.id === 'main-menu__toggle' && isMainMenuOpen === true) {
                    
                    isMainMenuOpen = false;
                    check_desktop.checked = false;
                    check_shop_button.checked = false;

                    return;
                }
            }

            check_desktop.checked = false;
            check_shop_button.checked = false;

            isShopMenuOpen = false;
            isMainMenuOpen = false;           
        }

        document.addEventListener('click', on_outside_click);

        function dont_bubble(e) {
            e.stopPropagation();
        }

        function activating() {
            opening = true;
        }

        desktop_menu_activation.addEventListener('click', dont_bubble);
        desktop_menu_activation.addEventListener('click', activating);

        shop_menu_activation.addEventListener('click', dont_bubble);
        shop_menu_activation.addEventListener('click', activating);

    }
)();

(function(){
    /* Mobile navigation support */
    var state = document.getElementById('mobile-menu-toggle');
    var activator = document.getElementById('mobile-menu-activation-area');
    var shop_mobile_menu_trigger = document.getElementById('shop-mobile-menu-trigger');
    shop_mobile_menu_trigger.addEventListener('click', handleShopMobileMenuTrigger)
    var isShopMenuOpen = false;
    var mainMenuRegularItems = document.querySelectorAll('.mobile-menu__regular-item')
    var shop_menu_mobile_container = document.getElementById('shop-mobile-menu-container')
    var mobile_menu_container = document.getElementById('mobile-main-menu-container');
    var opening = true;
    function on_outside_click(e) {
        if (opening) {
            opening = false;
            return;
        }
        state.checked = false;
    }
    document.addEventListener('click', on_outside_click);
    function dont_bubble(e) {
        e.stopPropagation();
    }
    function activating() {
        opening = true;
    }
    activator.addEventListener('click', dont_bubble);
    activator.addEventListener('click', activating);
    document.getElementById('mobile-menu-conainer').addEventListener('click', dont_bubble);
    document.getElementById('mobile-menu-close-icon').addEventListener('click', function(e){
        state.checked = false;
    });

    if (typeof SwpieDetect === "function") {
        SwpieDetect(
            mobile_menu_container,
            function(){},
            function(){},
            function(){},
            function(){
                on_outside_click();
            }
        );
    }

    function handleShopMobileMenuTrigger() {
        if (isShopMenuOpen === false) {
            // open
            mainMenuRegularItems.forEach((mainMenuRegularItem) => {
                mainMenuRegularItem.style.display = 'none'
            })
    
            shop_mobile_menu_trigger.classList.add('shop-mobile-menu-trigger-selected');
            shop_menu_mobile_container.style.display = 'block'
            isShopMenuOpen = true;
        } else {
            // close
            shop_mobile_menu_trigger.classList.remove('shop-mobile-menu-trigger-selected');
            shop_menu_mobile_container.style.display = 'none'

            mainMenuRegularItems.forEach((mainMenuRegularItem) => {
                mainMenuRegularItem.style.display = 'block'
            })
            isShopMenuOpen = false;
        }
    }
})();

/* Close banner script */
(function(){
    let now_ts = Math.floor(Date.now() / 1000);
    let closed_at = parseInt(window.localStorage.getItem('bar_closed'));
    if (!closed_at) closed_at = 0;
    let el_banner = document.getElementById('banner-container');

    let open_after = closed_at + (60*60*12);
    // let open_after = closed_at + 60;

    if (now_ts > open_after && el_banner) {
        el_banner.style['display'] = 'block';
    }

  let close_buttons = document.querySelectorAll('.header__banner-close-icon');
  for (let i = 0; i < close_buttons.length; i++) {
  	close_buttons[i].addEventListener('click', function(e){
    	now_ts = Math.floor(Date.now() / 1000);
      	window.localStorage.setItem('bar_closed', now_ts);
        if(el_banner)
      	    el_banner.style['display'] = 'none';
    });
  }
})();

/*
 * Dynamic script to rotate through a set of banner messages
 */
function BANNER_create_dynamic_banner(speed) {
    const el_messages_container = document.getElementById('banner-message-container');
    const els_messages = el_messages_container?.querySelectorAll("DIV");
    let message_index = window.localStorage.getItem('current_message_index');
    if (!message_index) {
        message_index = 0;
    }
    else {
        message_index = parseInt(message_index);
    }

    // let hdl_timer = setInterval(switch_message_timer, speed * 1000);

    if(els_messages && els_messages.length > 0) set_message();

    function set_message() {
        for (let i = 0; i < els_messages.length; i++) {
            els_messages[i].style.display = 'none';
        }
        if (message_index >= els_messages.length) {
            message_index = 0;
        }
        if (els_messages[message_index])
            els_messages[message_index].style.display = 'block';
    }

    function switch_message_timer() {
        const now_ts = Math.floor(Date.now() / 1000);
        let next_flip = window.localStorage.getItem('next_message_change');
        if (!next_flip) {
            next_flip = 0;
        }
        else {
            next_flip = parseInt(next_flip);
        }
        if (now_ts > next_flip) {
            message_index += 1;
            set_message();
            window.localStorage.setItem('current_message_index', message_index);
            window.localStorage.setItem('next_message_change', now_ts + speed);
        }
    }
}
